wbApp.controller('AttendanceLogSupportDetailCtrl', ['$scope', '$http', '$translate', 'localStorageService', 'rfidCardsSvc',
function ($scope, $http, $translate,localStorageService,  rfidCardsSvc) {

    $scope.title = '';
    $scope.isSaving = false;

    $scope.operationResultText = null;

    $scope.model = {
        fromDate: new Date(),
        toDate: new Date(),
        userIdType: 0,
        oldUserId: null,
        newUserId: null,
        userId: null,
        timeShiftInMinutes: 0,
        deviceSerialNumber: null
    };

    if (localStorageService.isSupported) {
        $scope.model.deviceSerialNumber = localStorageService.get('lastRfidCardDeviceSerialNumber');
    }

    $scope.$watch('model', function (model) {        
        if (localStorageService.isSupported) {
            localStorageService.set('lastRfidCardDeviceSerialNumber', model.deviceSerialNumber);
        }
    }, true);

    $scope.modelOrig = angular.copy($scope.model);

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };

    $scope.onUserTypeChange = function (model) {
        model.oldUserId = null;
        model.newUserId = null;
        model.userId = null;
    }

    switch ($scope.operationMode)
    {
        case 'delete-all-in-range':
            $scope.title = $translate.instant('TXT_TITLE_DELETE_ALL_IN_RANGE');
            break;
        case 'delete-user-in-range':
            $scope.title = $translate.instant('TXT_TITLE_DELETE_USER_IN_RANGE');
            break;
        case 'replace-user-in-range':
            $scope.title = $translate.instant('TXT_TITLE_REPLACE_USER_IN_RANGE');
            break;
        case 'shift-time-in-range':
            $scope.title = $translate.instant('TXT_TITLE_SHIFT_TIME_IN_RANGE');
            break;
    }

    $scope.onDetailSave = function (model) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        $scope.operationResultText = null;

        var dto = {
            fromDateUtc: moment(model.fromDate).utc().format(),
            toDateUtc: moment(model.toDate).utc().format()
        }

        switch ($scope.operationMode) {
            case 'delete-all-in-range':
                dto.events = [];
                dto.uploadContacts = [];
                rfidCardsSvc.supportReplaceRange(dto).$promise.then(success, error);
                break;
            case 'delete-user-in-range':
                dto.userId = model.userId;
                dto.userIdType = model.userIdType;
                rfidCardsSvc.supportDeleteUserInRange(dto).$promise.then(successWithTextDecode, error);
                break;
            case 'replace-user-in-range':
                dto.oldUserId = model.oldUserId;
                dto.newUserId = model.newUserId;
                dto.userIdType = model.userIdType;
                rfidCardsSvc.supportReplaceUserInRange(dto).$promise.then(successWithTextDecode, error);
                break;
            case 'shift-time-in-range':
                {
                    var duration = moment.duration(model.timeShiftInMinutes, 'minutes');
                    if (model.timeShiftInMinutes < 0) {
                        dto.timeShift = '-' + Math.abs(duration.days()) + '.' + ("0" + Math.abs(duration.hours())).slice(-2) + ':' + ("0" + Math.abs(duration.minutes())).slice(-2) + ':' + ("0" + Math.abs(duration.seconds())).slice(-2);
                    } else {
                        dto.timeShift = duration.days() + '.' + ("0" + duration.hours()).slice(-2) + ':' + ("0" + duration.minutes()).slice(-2) + ':' + ("0" + duration.seconds()).slice(-2);
                    }
                    dto.deviceSerialNumber = model.deviceSerialNumber;
                    rfidCardsSvc.supportShiftOriginEventInRange(dto).$promise.then(success, error);
                }
                break;
        }

        //if (!model.rfidCardLogID) {
        //    rfidCardsSvc.insert(model, $scope.collection, success, error);
        //} else {
        //    rfidCardsSvc.update(model, $scope.collection, success, error);
        //}

        function successWithTextDecode(result) {
            if (result.length == 0) {
                $scope.isSaving = false;
                $scope.$hide();
                if (!!$scope.onSave) {
                    $scope.onSave();
                }
            } else {
                error(result);
            }
        }

        function success() {
            $scope.isSaving = false;
            $scope.$hide();
            if (!!$scope.onSave) {
                $scope.onSave();
            }
        }

        function error(data) {
            $scope.isSaving = false;
            $scope.operationResultText = data;
        }
    }
}]);
